import { api } from '../../../api/client';

export const renapoSystemConfigurationsApi = {
  /** Obtiene la configuración activa de RENAPO */
  getActive: () => api.get('/system-configuration/renapo'),

  /** Actualiza la configuración de RENAPO */
  update: (data) => api.put('/system-configuration/renapo', data),
};
